module.exports = __webpack_public_path__ + "img/gonetwork0_3.199a870a.png";